import React from "react";
import AwardsAchievementsImage from "./assests/AwardsAchievementsImage.png";
import "../style/awarsAchievements.css";
import Carousel from "./Carousel";
const VisionMission = () => {
  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <img src={AwardsAchievementsImage} class="" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <p className="awards">Awards</p>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <p className="award-description">
              At every stage, we at Guru Harkrishan High School & Jr. College of
              Commerece, acknowledge the achievements and progress of our
              students by giving them recognition and awards. We always
              encourage our students to go in for competitions not only to win
              prizes but to develop a healthy spirit of competition. We believe
              that spirit of participation will take them a long way to
              withstand the challenges of real life competition and enable them
              to be competent.
            </p>
          </div>
        </div>
      </div>
      <h1 class="custom-heading mt-0 text-3xl">SPORTS ACHIEVEMENTS</h1>
      <Carousel /> <br /> <br />
    </div>
  );
};

export default VisionMission;
